import { IEntity } from "@interfaces/entity"

export class ChargingPowerProfile implements IEntity {
  id: number
  name: string
  key: string

  entityName = "ChargingPowerProfile"

  constructor(formValue?: Partial<ChargingPowerProfile>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<ChargingPowerProfile>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
